import React from 'react';
import { TableRow } from './TableRow';
import { NoRows } from '../../../layout/Table/NoRows';

function TableBody(props) {
  const renderRows = () => {
    const { campaigns } = props;

    if (!Array.isArray(campaigns) || campaigns.length === 0) {
      return <NoRows colSpan="8"/>;
    }

    return campaigns.map(renderRow);
  };

  const renderRow = (campaign, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        shouldRenderFields={ props.shouldRenderFields }
        key={ index }
        campaign={ campaign }
        actionCallback={ actionCallback }
        index= { index }
      />
    )
  }
    return (
      <tbody>
      { renderRows() }
      </tbody>
    )
}

export { TableBody };
